export const webConfig = {
  apiUrl: window.webConfig.apiUrl,
  caProxyUrl: window.webConfig.caProxyUrl
};

export const version = {
  backSynchronized: '1.0',
  display: '1.0'
};